function NotFound() {
    return (
        <div className="pageContainer">
            <h1>404 - Seite nicht gefunden</h1>
            <p>Die angeforderte Seite existiert nicht.</p>
            <p>Bitte überprüfen Sie die URL oder gehen Sie zurück zur <a href="/">Startseite</a>.</p>
        </div>
    );
}

export default NotFound;